export default "__VITE_ASSET__CuYASYtM__"